import { createContext, useCallback, useEffect, useState } from "react";
import { API_PUBLIC_HOST } from "@/_constant/urlconstants";
import { decompressData } from "@/utility/common-utils";
import api from "@/apis/request";

const LanguageContext = createContext();

function LanguageProvider({ children }) {

    const [languageData, setLanguageData] = useState(new Map());
    const [defaultLang, setDefaultLang] = useState('English');
    const [languageList, setLanguageList] = useState([]);

    function changeLanguage(lang='English'){
        setDefaultLang(lang);
    }

    function language(key = '', defaultValue = null) {
        const value = languageData.get(key);
        if(value){
            return value;
        }
        return defaultValue;
    }

    function arrayToMap(dataList){
        const langMap = new Map();
        dataList.forEach(el => langMap.set(el.displayCode, el.value));
        setLanguageData(langMap)
    }

    const fetchLanguageData = useCallback(() =>{
        const URL = `${API_PUBLIC_HOST}/lookup/language-pack?display_code=*&languagePackType=NORMAL&viewCompressed=true&language=${defaultLang}`;
        api.get(URL).then((response) => {
            const dataList = decompressData(response?.data?.response);
            arrayToMap(dataList);
        })
        .catch((error) => {
            console.log(error);
        });
    }, [defaultLang])

    const fetchLanguageList = () => {
        api.get(`${API_PUBLIC_HOST}/lookup/language`)
        .then((response) => {
            const items = [];
            let item = localStorage.getItem('language');
            response?.data?.response?.forEach((item, i) => {
                items.push(item);
            });
            setLanguageList(items);
            if (item === null) {
                item = items[0];
                localStorage.setItem('language', JSON.stringify(item));
            }
        })
        .catch((error) => {
            console.log(error);
            setLanguageList([]);
        });
    };

    useEffect(() => {
        fetchLanguageData();
    }, [fetchLanguageData])

    useEffect(() => {
        fetchLanguageList();
    }, [])
    
    const languageContext = {
        languageData,
        defaultLang,
        language,
        changeLanguage,
        languageList,
    }

    return (
        <LanguageContext.Provider value={languageContext}>
            {children}
        </LanguageContext.Provider>
    )
}

export default LanguageContext;
export { LanguageProvider };